// extracted by mini-css-extract-plugin
export default {"container":"Home_container__GBJSz","h1":"Home_h1__KwZ9e"};